import http from 'utils/http';

export const fetchOrderEstimate = (data) => http
  .post('v1/orders/call-in-orders/estimate/', data)
  .then((res) => res.data);

export const createDirectEntryOrder = (data) => http.post('v1/orders/call-in-orders/', data).then((res) => res.data);
